var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('extended-page-header',{attrs:{"title":_vm.$t('paths.logs')}}),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }